import { useEffect, useState } from "react";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminContactPage() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMessages = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${BASE_URL}/contact/all`);
      const data = await res.json();

      setMessages(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const deleteMessage = async (id) => {
    const confirmDelete = window.confirm("Delete this message?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(`${BASE_URL}/api/contact/delete/${id}`, {
        method: "DELETE",
      });

      const data = await res.json();

      if (res.ok) {
        alert("Deleted successfully");
        setMessages(messages.filter((msg) => msg.id !== id));
      } else {
        alert(data.error || "Delete failed");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>📩 Contact Messages</h1>

      {loading ? (
        <p>Loading messages...</p>
      ) : messages.length === 0 ? (
        <p>No messages found</p>
      ) : (
        <>
          {/* ===== DESKTOP TABLE ===== */}
          <div className="table-view" style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Email</th>
                  <th style={styles.th}>Subject</th>
                  <th style={styles.th}>Message</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {messages.map((msg) => (
                  <tr key={msg.id}>
                    <td style={styles.td}>{msg.id}</td>
                    <td style={styles.td}>{msg.name}</td>
                    <td style={styles.td}>{msg.email}</td>
                    <td style={styles.td}>{msg.subject}</td>
                    <td style={styles.td}>{msg.message}</td>
                    <td style={styles.td}>
                      <button
                        onClick={() => deleteMessage(msg.id)}
                        style={styles.deleteBtn}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ===== MOBILE CARDS ===== */}
          <div className="mobile-view">
            {messages.map((msg) => (
              <div key={msg.id} style={styles.card}>
                <p><b>ID:</b> {msg.id}</p>
                <p><b>Name:</b> {msg.name}</p>
                <p><b>Email:</b> {msg.email}</p>
                <p><b>Subject:</b> {msg.subject}</p>
                <p><b>Message:</b> {msg.message}</p>

                <button
                  onClick={() => deleteMessage(msg.id)}
                  style={styles.deleteBtn}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* ===== RESPONSIVE STYLE INSIDE COMPONENT ===== */}
      <style>
        {`
          .mobile-view {
            display: none;
          }

          @media (max-width: 768px) {
            .table-view {
              display: none !important;
            }

            .mobile-view {
              display: block !important;
            }
          }
        `}
      </style>
    </div>
  );
}
// ---------- STYLES ----------
const styles = {
  container: {
    padding: "20px",
    background: "#f5f6fa",
    minHeight: "100vh",
    fontFamily: "Arial",
  },

  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "28px",
  },

  tableWrapper: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff",
    minWidth: "900px",
  },

  th: {
    background: "#c59d5f",
    color: "#fff",
    padding: "12px",
    textAlign: "left",
    border: "1px solid #ddd",
  },

  td: {
    padding: "12px",
    border: "1px solid #ddd",
    verticalAlign: "top",
  },

  deleteBtn: {
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    background: "#e74c3c",
    color: "#fff",
    cursor: "pointer",
  },

  // ===== MOBILE CARDS =====
  mobileWrapper: {
    display: "none",
  },

  card: {
    background: "#fff",
    padding: "15px",
    marginBottom: "15px",
    borderRadius: "10px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
  },
};